import { AppBar, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../common/constants";
import { IResponse, IServerError } from "../../models/common";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {

	formatDate,
	sortDDLByLabel,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AuthService } from "../../services";
import { CompanyTD1FormService } from "../../services/CompanyTD1FormService";
import { DateRange } from "@mui/icons-material";
import { EmployeeService } from "../../services/EmployeeService";
import FileSaver from "file-saver";
import { IAppState } from "../../store/reducers";
import { IDropDownListResponse } from "../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../models";
import { LookupFieldService } from "../../services/LookupFieldService";
import { ReportsService } from "../../services/ReportsService";
import { ROEListDataGridWithColumnToggled } from "./ROEListDataGridWithColumnToggled";
import { ROEListHeader } from "./ROEListHeader";
import { endOfDay } from "date-fns";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";
import { ROEListSetupToolbar } from "./ROEListSetupToolbar/ROEListSetupToolbar";
import { ROEService } from "../../services/ROEService";
import { BasicSetupFormToolbar } from "../BasicSetupFormToolbar";

export interface IROEListSetupPage { }
const ROE_LIST = "roe-list";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";

const useROEListData = (
	runGetListAPICall: boolean,
	clientId: string,
	employeeId: string,
	roeStatus: string,
	params: IGetListRequest
) =>
	useQuery({
		queryKey: [
			ROE_LIST,
			runGetListAPICall,
			clientId,
			employeeId,
			roeStatus,
			params
			,],
		queryFn: () =>
			ROEService.getROEListData(
				runGetListAPICall,
				clientId,
				employeeId,
				roeStatus,
				params,
			),
		refetchOnWindowFocus: false,
	});


export const useGetLookupFieldData = (lookupFieldId: string) =>
	useQuery({
		queryKey: [GET_QUERY_KEY.LOOKUP_FIELD_DATA_BY_ID, lookupFieldId],
		queryFn: (data) => {
			return LookupFieldService.getByIdd(lookupFieldId);
		},
		refetchOnWindowFocus: false,
	});

const useGetEmployeeDDLItems = (
	clientId: string,
	status: number,
	taxYear: number
) =>
	useQuery({
		queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, status, taxYear],
		queryFn: (data) => {
			return CompanyTD1FormService.getEmployeeDDLByStatus(clientId, status, taxYear);
		},
		refetchOnWindowFocus: false,
	});


export const ROEList: React.FC<IROEListSetupPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const [roeListData, setRoeListData] =
		useState<any>(undefined);
	const [runGetListAPICall, setRunGetListAPICall] =
		useState<any>(true);
	const [employeeStatus, setEmployeeStatus] = useState<any>("all");
	const [openDialog, setDialogOpen] = useState(false);

	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const employeeId = formMethods.watch("employeeDDL");
	const status = formMethods.watch("status");

	const { isPending, data } = useROEListData(
		runGetListAPICall,
		clientId,
		employeeId,
		status,
		queryParams
	);
	const ROEList: any | null = data;


	useEffect(() => {
		if (ROEList) {
			
			setRoeListData(ROEList);
		}
	}, [ROEList]);

	const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
		useGetEmployeeDDLItems(clientId, employeeStatus, taxYear);

	const onROEApiGetCall = (
				// employeeId:string,
				// 	status:string,
	) => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const response: any = await ROEService.getROEListData(
					true,
					clientId,
					employeeId,
					status,
					queryParams,
				);
				setRoeListData(response)
			} catch {
			} finally {
				setIsLoading(false);

			}
		};
		fetchData();
	};


	const onSubmit = (values: any) => {
		
		onROEApiGetCall(
			// values.employeeId,
			// values.status
		)
	};

	const [zeroEmployee, setzeroEmployee] = useState(true);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
		setRunGetListAPICall(true)
	}, []);

	const employeeDDlItems = useMemo(() => {
		if (employeeDDLItems) {
			if (
				employeeDDLItems &&
				Array.isArray(employeeDDLItems)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(employeeDDLItems).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [employeeDDLItems]);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["roe-list"]);

	const updatedROEListItems = useMemo(() => {
		return (
			roeListData &&
			roeListData.items &&
			roeListData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [roeListData]);

	const onEmployeeSelectionChangeHandler = (event: any) => {
		setRunGetListAPICall(true)
		// setEmployeeStatus("status")
	};
	const onEmployeeStatusSelectionChangeHandler = (event: any) => {
		setRunGetListAPICall(true)
		// formMethods.setValue('employeeDDL', "all")
		// setEmployeeStatus(event.value);
		formMethods.setValue('status', event.value)
	};

	const expandedLabels = ["Compliance", "ROE"];
	const expandedROEListItem = "List";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "ROE" &&
				item.label === expandedROEListItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedROEListItem && "/compliance/roe/list",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);


	const selectionToolbar = useCallback(
		(selectedItems: any) => {

			if (selectedItems && selectedItems.length) {
				return (
					<BasicSetupFormToolbar pageTitle={""} />
				);
			}
			return (
				<></>
			);
		},
		[]
	);

	// const onDeleteClicked = () => {
	// 	setDialogOpen(true)
	// };

	// const onCloseHandler = () => {
	// 	setDialogOpen(false);
	// };

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"ROE List"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<ROEListHeader
						employeeDDLList={employeeDDlItems}
						onEmployeeSelectionChangeHandler={onEmployeeSelectionChangeHandler}
						onEmployeeStatusSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
						selectedItem={status}
						setStateRunGetListAPICall={(value: boolean) => setRunGetListAPICall(value)}
					/>
					{/* <ROEListSetupToolbar
						onDeleteClicked={onDeleteClicked}
						id={employeeId}
					/> */}
				</form>

			</FormProvider>

			{/* <BasicSetupFormToolbar pageTitle={""}/> */}

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isPendingEmployeeDDLItems
					}
					testId="roe-list"
				/>
				<ROEListDataGridWithColumnToggled
					columns={
						roeListData?.headerColumns
							? roeListData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
						// roeListData?.headerColumns ?? []
					}
					completeHeaderColumnsList={
						// roeListData
						// 	&& roeListData
						// 		?.totalHeaderColumns &&
						// 	Object.keys(roeListData.totalHeaderColumns).length !== 0 /// comment for use hardcoded data change later
						// 	? roeListData.totalHeaderColumns
						// 	: {}
						roeListData?.headerColumns ?? []
					}
					submitAddRemoveColumnsHandler={(value: any) =>
						setSubmitAddRemoveColumnsHandler(value)
					}
					onColumnReorder={(value: any) => setOnColumnReorder(value)}
					rows={
						roeListData && updatedROEListItems
							? updatedROEListItems
							: []
						// roeListData?.items ?? []
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						ROEList && ROEList.total
							? ROEList.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					pageTitle="ROE List"
				/>

				{roeListData ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							backgroundColor: "#F7F7F7",

							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					></AppBar>
				) : (
					<></>
				)}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
